import { clearingApi } from "../../config/apiConfig";

export const getAllNotes = async () => {
  try {
    const response = await clearingApi.post(`credit-notes/all`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getNotesByDate = async ({ stationId, month, year }) => {
  try {
    const response = await clearingApi.post(
      `credit-notes?station_id=${stationId}&year=${year}&month=${month}`
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const generateCreditNotes = async ({
  customerId,
  year,
  month,
  inDetail = false,
}) => {
  if (!customerId || !year || !month) {
    console.warn(
      `[generateCreditNotes] MISSING INFO: \n CustomerId: ${customerId} \n Date: ${month} ${year}`
    );
    return;
  }

  const endpoint = inDetail
    ? `credit-notes/customer/in-details?customer_id=${customerId}&year=${year}&month=${month}`
    : `credit-notes/customer?customer_id=${customerId}&year=${year}&month=${month}`;

  try {
    const response = await clearingApi.post(endpoint);

    if (response?.status >= 300) {
      console.log("generate credit notes", response);
      return false;
    }

    return true;
  } catch (e) {
    console.error(
      "Failed to generate credit notes for customer",
      customerId,
      e
    );
    return false;
  }
};

export const generateCreditNoteByStationId = async ({
  stationId,
  year,
  month,
}) => {
  if (!year || !month || !stationId) {
    console.warn(
      `[generateCreditNoteByStationId] MISSING INFO: ${stationId} \n Date: ${month} ${year}`
    );
    return;
  }

  try {
    const response = await clearingApi.post(
      `credit-notes?station_id=${stationId}&year=${year}&month=${month}`
    );

    if (response?.status >= 300) {
      console.log("generate credit notes by station id", response);
      return false;
    }

    return true;
  } catch (e) {
    console.error("Failed to generate credit note for station.", stationId, e);
    return false;
  }
};

export const getCustomerCreditNotes = async ({ customerId }) => {
  const response = await clearingApi.get(
    `credit-notes/customer/${customerId}`
  );
  return response.data;
};

export const generateCreditNotesForAllCustomers = async ({ year, month } = {}) => {
  try {
    let url = `credit-notes/customer/all`;
    if (year != null && month != null) {
      url += `?year=${year}&month=${month}`;
    }
    await clearingApi.post(url);
    return { status: "started" };
  } catch (e) {
    if (e?.response?.status === 409) {
      return { status: "already_running" };
    }
    console.error("Failed to generate credit notes for all customers.", e);
    return { status: "error" };
  }
};

export const getCreditNoteProcessingStatus = async () => {
  try {
    const response = await clearingApi.get(`credit-notes/processing-status`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCreditNoteSummaries = async ({ page = 1, limit = 20 } = {}) => {
  try {
    const response = await clearingApi.get(
      `credit-notes/summaries?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getGenerationRuns = async (limit = 50) => {
  try {
    const response = await clearingApi.get(
      `credit-notes/generation-runs?limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBankTransferXMLs = async ({ month, year }) => {
  try {
    const response = await clearingApi.post(
      `generate-sepa-xml?month=${month}&year=${year}`
    );

    if (response?.status >= 300) {
      console.log("download bank transfer xmls failed:", response);
      return false;
    }

    const blob = new Blob([response?.data], { type: "application/xml" });

    return blob;
  } catch (e) {
    console.error(
      "Failed to download bank transfer xmls for all customers.",
      e
    );
    return false;
  }
};
